import { type SvgIconProps } from "@mui/material/SvgIcon";
import { type FC } from "react";
import { matchPath, useLocation } from "react-router";

import { ROUTES } from "~/constants/routing";

import {
  iconByIndicesTabEnum,
  IndicesTabEnum,
  labelByIndicesTabEnum,
} from "./constants";

export type IndicesTab = {
  key: string;
  label: string;
  icon: FC<SvgIconProps> | null;
  to: string;
  isActive: boolean;
};

const indicesTabConfig = [
  {
    key: IndicesTabEnum.WAR,
    label: labelByIndicesTabEnum[IndicesTabEnum.WAR],
    icon: iconByIndicesTabEnum[IndicesTabEnum.WAR],
    path: ROUTES.warIndex.path,
    to: ROUTES.warIndex.createURL(),
  },
];

export const useIndicesTabs = (): IndicesTab[] => {
  const { pathname } = useLocation();

  return indicesTabConfig.map(({ key, label, to, path, icon }) => ({
    key,
    label,
    icon,
    to,
    isActive: !!matchPath({ path, end: true }, pathname),
  }));
};
